import React from 'react'
import Scrollbars from 'react-custom-scrollbars'
import { isSafari } from '../../../../components/DetectBrowser/DetectBrowser'
import { MenuList } from '../../../../components/Template/Sidebar'
import SafariWrapper from './SafariWrapper'

export function Null() {
  return <div style={{ display: 'null' }}></div>
}

export default function SidebarContent({ children, size = 1 }: any) {
  const preventDefault = e => {
    e.preventDefault()
    e.stopPropagation()
  }

  if (isSafari()) {
    return (
      <SafariWrapper size={size}>
        <MenuList safari={true} onTouchMove={preventDefault}>
          {children}
        </MenuList>
      </SafariWrapper>
    )
  } else {
    return (
      <Scrollbars
        renderThumbHorizontal={Null}
        renderTrackHorizontal={Null}
        style={{ minHeight: `calc(var(--full) - ${110 * size}px)` }}
      >
        <MenuList size={size}>{children}</MenuList>
      </Scrollbars>
    )
  }
}
